import { useCallback } from 'react'
import { useStateValue } from 'context/store'
import { openSpinnerAction, closeSpinnerAction } from 'context/reducers/openSpinnerReducer'
import { openSnackBarAction, closeSnackbarAction } from 'context/reducers/openSnackbarReducer'

export function handleErrorMessage(error) {
   if (!error) return 'Error desconocido.'
   const response = error?.responseStatus
   const data = error?.data || {}
   const status = data.status ?? response?.status

   const mainMsg = data.message || data.localizedMessage || ''
   if (typeof status === 'undefined') {
      return (
         mainMsg ||
         'Se presentó un problema de CORS, conexión caída o el servidor no responde, verifíque su conexión o contacte a soporte.'
      )
   }
   switch (status) {
      case 400:
         return mainMsg || 'Se presentó un error en los datos enviados al servidor, contacte a soporte.'
      case 401:
      case 403:
         return (
            mainMsg ||
            'Ha ocurrido un error. Por favor, cierre la sesión e intente nuevamente. Si el inconveniente persiste, contacte a soporte.'
         )
      case 404:
         return mainMsg || 'Recurso no encontrado (404), contacte a soporte.'
      default:
         return mainMsg || 'Se presentó un error, contacte a soporte.'
   }
}

export function useApiRequest(apiAction, location, showSpinner = true) {
   const [_, dispatch] = useStateValue()

   const callApi = useCallback(
      async (...params) => {
         try {
            showSpinner && dispatch(openSpinnerAction())
            dispatch(closeSnackbarAction())
            const apiPromise = apiAction(...params)
            if (!(apiPromise instanceof Promise)) {
               dispatch(openSnackBarAction(`Se presentó un error de javascript en llamado al servicio ${location}.`))
            }
            const response = await apiPromise
            showSpinner && dispatch(closeSpinnerAction())
            return response
         } catch (error) {
            dispatch(closeSpinnerAction())
            dispatch(openSnackBarAction(`${handleErrorMessage(error)} (${location})`))
         }
      },
      [apiAction, location]
   )

   return callApi
}
